<template>
  <div class="result-box">
    <div class="search-input-box">
      <van-icon name="arrow-left" size="25" @click="leftBut" />
      <van-field
        class="search-input"
        v-model="searchValue"
        clearable
        placeholder="输入搜索内容"
      />
      <span class="search-btn" @click="toSearch">搜索</span>
    </div>
    <van-tabs
      class="result-tabs"
      v-model="active"
      title-active-color="#4A79F1"
      title-inactive-color="#333"
      color="#4A79F1"
      line-height="2px"
      line-width="20px"
      sticky
      offset-top="100"
      @change="tabChange"
    >
      <van-tab
        v-for="item in navList"
        :key="item.id"
        :name="item.id"
        :title="item.title"
      ></van-tab>
    </van-tabs>
    <Details :active="active" />
  </div>
</template>

<script>
import { Tab, Tabs } from "vant";
import Details from "@/views/mobileView/search/components/details.vue";
export default {
  name: "SearchResult",
  components: {
    "van-tabs": Tabs,
    "van-tab": Tab,
    Details,
  },
  data() {
    return {
      searchValue: "",
      active: 1,
      navList: [
        { id: 1, title: "综合" },
        { id: 2, title: "论文" },
        { id: 3, title: "资讯" },
        { id: 4, title: "专著" },
        { id: 5, title: "会议" },
        { id: 10, title: "课程" },
        { id: 11, title: "行业报告" },
        { id: 6, title: "学者" },
        { id: 7, title: "期刊" },
        { id: 8, title: "机构" },
        { id: 9, title: "名录" },
      ],
    };
  },
  created() {
    this.searchValue = this.$route.query.paramStr;
    // let isActive = sessionStorage.getItem("searchActive");
    // console.log(isActive,'isActive');
    // this.active = +isActive ? +isActive : 1
  },
  mounted() {
    this.$bus.$on("changeTabs", (index) => {
      this.active = +index;
    });
  },
  methods: {
    // 左侧按钮(gubeit为协商的方法名)
    leftBut() {
      window.history.go(-1);
      // sessionStorage.removeItem('searchActive') 
    },
    // 搜索
    toSearch() {
      if (this.searchValue == "" || this.searchValue == this.$route.query.paramStr) return; //如果没有关键字则不跳转
      this.recentSearch(this.searchValue); // 调用该方法存储搜索的内容
      this.$router.replace({ query: { paramStr: this.searchValue } });
    },
    // 累加存储(最近搜索)
    recentSearch(data) {
      const list = JSON.parse(localStorage.getItem("recentSearch")) || []; // 先取出
      if (list.indexOf(data) !== -1) return;
      if (list.length >= 10) {
        // 最多15个,超出将最后一个删除,在第一个位置添加新内容
        list.splice(list.length - 1, 1);
        list.unshift(data);
      } else {
        list.unshift(data); // 将要累加的数据push进数组中
      }
      localStorage.setItem("recentSearch", JSON.stringify(list)); // 将取出的内容再次存储
    },
    // 保存搜索tab
    tabChange(active) {
      // sessionStorage.setItem("searchActive", active);
    },
  },
  beforeDestroy() {
    this.$off("changeTabs");
  },
};
</script>

<style scoped lang="scss">
.result-box {
  background-color: #f5f5f5;
  min-height: 100vh;
  .search-input-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 15px 5px;
    background-color: #fff;
    .search-input {
      padding: 6px 18px;
      width: 274px;
      //   height: 35px;
      background-color: #f5f5f5;
      border-radius: 18px;
    }
    .search-btn {
      font-size: 15px;
      color: #333333;
      line-height: 21px;
    }
  }
  .result-tabs {
    &::v-deep .van-tabs__nav--line {
      padding-bottom: 0px;
      .van-tab {
        font-size: 15px;
      }
      .van-tab--active {
        font-weight: 700;
        font-size: 16px;
      }
      .van-tabs__line {
        bottom: 5px;
      }
    }
  }
}
</style>